import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    header: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        padding: '40px 24px 32px',
    },
    checkIcon: {
        fontSize: 72,
        marginBottom: 20,
        color: theme.palette.primary.main,
    },
    subtitle: {
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: '0.1em',
        color: theme.palette.grey[400],
        textTransform: 'uppercase',
        margin: '0 0 12px',
    },
    heading: {
        fontSize: 32,
        fontWeight: 700,
        color: theme.palette.grey[800],
        margin: '0 0 16px',
        lineHeight: 1.2,
    },
    body: {
        fontSize: 16,
        color: theme.palette.grey[600],
        margin: 0,
        maxWidth: 520,
        lineHeight: 1.6,
    },
    nextStepContainer: {
        maxWidth: 850,
        margin: '0 auto',
    },
    nextStepBody: {
        padding: '24px 28px !important',
    },
    nextStepRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 20,
    },
    nextStepContent: {
        flex: 1,
    },
    nextStepLabel: {
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.1em',
        color: theme.palette.grey[600],
        textTransform: 'uppercase',
        margin: '0 0 12px',
    },
    nextStepInner: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 16,
    },
    stepTitle: {
        fontSize: 16,
        fontWeight: 700,
        color: theme.palette.grey[800],
        margin: '0 0 4px',
    },
    stepDescription: {
        fontSize: 14,
        color: theme.palette.grey[600],
        margin: 0,
        lineHeight: 1.5,
    },
    ctaButton: {
        flexShrink: 0,
        padding: '14px 24px',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
    },
}));
